<template>
  <div>
    <BobDisplayForm
      :config="{
        rowGap: 8,
        labelWidth: '80px',
      }"
      :fields="displayFields"
    />
  </div>
</template>

<script>
import BobDisplayForm from '@/components/BobDisplayForm.vue'
import { get } from 'lodash'
import { defineComponent, computed } from 'vue'
import { cancelReasonConfig, cancelSourceConfig } from '@/config/reservation'
import { useShop } from '@/use/shop'
import dayjs from '@/lib/dayjs'

export default defineComponent({
  name: 'CancelInfoBlock',
  components: {
    BobDisplayForm,
  },
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props) {
    const { shopTimezone } = useShop()

    const displayFields = computed(() => {
      const cancelReasonCode = get(props.order, 'AppointmentOrder.cancelReasonCode')
      const cancelSource = get(props.order, 'AppointmentOrder.cancelSource')

      return [
        // 取消原因
        {
          prop: 'cancelReasonCode',
          label: '取消原因',
          body: {
            component: 'Tag',
            props: {
              type: get(cancelReasonConfig[cancelReasonCode], 'tag'),
            },
            render: () => get(cancelReasonConfig[cancelReasonCode], 'label'),
          },
        },
        // 取消備註
        {
          prop: 'cancelReasonNote',
          label: '取消備註',
          body: {
            component: 'div',
            render: () => get(props.order, 'AppointmentOrder.cancelReasonNote') || '顧客未填寫',
          },
        },
        // 取消時間
        {
          prop: 'cancelAt',
          label: '取消時間',
          body: {
            component: 'div',
            render: () => {
              const cancelAt = get(props.order, 'AppointmentOrder.cancelAt')
              return cancelAt ? dayjs(cancelAt, shopTimezone.value).format('YYYY/MM/DD HH:mm:ss') : '-'
            },
          },
        },
        // 取消來源
        {
          prop: 'cancelSource',
          label: '取消來源',
          body: {
            component: 'div',
            render: () => get(cancelSourceConfig[cancelSource], 'label', '-'),
          },
        },
      ]
    })

    return {
      displayFields,
    }
  },
})
</script>

<style lang="postcss" scoped></style>
